import { useEffect } from "react";

const SITE = "https://upvservices.com";

export const Seo = ({ title, description, path = "/", jsonLd = [] }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE}${path}`);

    const added = [];
    jsonLd.forEach((obj, i) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-page", "true");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      added.push(s);
    });

    return () => added.forEach((s) => s.remove());
  }, [title, description, path, jsonLd]);

  return null;
};
